import { render, staticRenderFns } from "./sortManage.vue?vue&type=template&id=aeb05712"
import script from "./sortManage.vue?vue&type=script&lang=js"
export * from "./sortManage.vue?vue&type=script&lang=js"
import style0 from "./sortManage.vue?vue&type=style&index=0&id=aeb05712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports